import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Button } from '@mui/material';

/**
 *
 * @param {string} label
 * @param {function} onClick
 * @param {string} backgroundColor
 * @returns {JSX.Element}
 */
export default function VCardPreviewAddContactButton({ label, onClick, backgroundColor }) {
  return (
    <Button
      startIcon={<PersonAddIcon sx={{ width: '14px', height: '14px' }} />}
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor,
        wordBreak: 'break-word',
        height: '26px',
        borderRadius: '64px',
        textTransform: 'none',
        fontSize: '11.6px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '12px',
        width: 'fit-content',
        '&:hover': {
          backgroundColor,
        },
      }}
    >
      {label}
    </Button>
  );
}
